import { OdataManager } from '@/api/odata/odata-manager';
import { FinalBook } from '@/api/model/interfaces';

export default class FinalBookOdata extends OdataManager<FinalBook> {}
